import { createQueryKeys } from "@lukemorales/query-key-factory";
import { PostModel } from "common/models/BaseModel";
import { IListResponse } from "common/models/GridModels";
import { IDropdownModel } from "common/models/IDropdownModel";
import api from "utils/api";
import { endpoints } from "utils/endpoints";
import { ISection, ISectionGridFilter, ISectionGridModel } from "./types";
import { sectionView } from "../types/sectionView";

export const section = createQueryKeys("section", {
  list: (postModel: PostModel<ISectionGridFilter>) => ({
    queryKey: [postModel],
    queryFn: () =>
      api.post<IListResponse<ISectionGridModel>>(
        endpoints.section.list,
        postModel
      ),
  }),

  getById: (Id: string | number) => ({
    queryKey: [Id],
    queryFn: () => api.get<ISection>(`${endpoints.section.getById}/${Id}`),
  }),

  getSectionValues: () => ({
    queryKey: ["GetSectionValues"],
    queryFn: () =>
      api.get<IDropdownModel[]>(endpoints.section.getSectionValues),
  }),

  getViewById: (Id: string | number) => ({
    queryKey: ["modal", Id],
    queryFn: () => api.get<sectionView>(`${endpoints.section.view}/${Id}`),
  }),
});
